module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_has.js
// module id = 17
// module chunks = 34471704633725 35783957827783 216468464745311